import {maybe} from '@freckle/maybe'
import {saferStringify} from '@freckle/parser'
import isError from 'lodash/isError'
import isNil from 'lodash/isNil'

import {isNetworkError} from '../helpers/ajax/helpers/errors/is-network-error'
import {
  ClientNetworkError,
  ClientRequestAbortError
} from '../helpers/ajax/helpers/errors/native-fetch-errors'

export class HttpError extends Error {
  status: number | undefined | null
  isClientNetworkError: boolean
  isAbortError: boolean

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(err: any) {
    super(createErrorMessage(err))
    this.name = 'HttpError'
    // These propeties are using in filterAndNotify for bugsnag
    this.status = err?.status
    this.isClientNetworkError = err instanceof ClientNetworkError || isNetworkError(err)
    this.isAbortError =
      err instanceof ClientRequestAbortError || (err instanceof Error && err.name === 'AbortError')
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function createErrorMessage(err: any): string {
  const responseBody = maybe(
    () => err?.response?.text,
    json => saferStringify(json),
    err?.response?.json
  )

  if (!isNil(err?.status) && !isNil(responseBody)) {
    return `Unexpected HTTP error: ${err.status} - ${responseBody}`
  }

  if (isError(err)) {
    return `Unexpected HTTP error: ${err.message}`
  }

  return `Unexpected HTTP error: ${saferStringify(err)}`
}
